export interface KycMergePersonDetails {
  firstName: string;
  surname: string;
  /** YYYY-MM-DD */
  dateOfBirth: string;
}

const displayDob = (value: string): string => {
  const [year, month, day] = value.slice(0, 10).split('-');
  return year && month && day ? `${day}/${month}/${year}` : 'no date of birth';
};

const fullName = (person: KycMergePersonDetails): string => [person.firstName, person.surname].filter(Boolean).join(' ');

const normalise = (value: string): string => value.trim().toLowerCase();

/**
 * The one name and date-of-birth rule for a verified KYC result, used by the FrankieOne callback and
 * the merge recheck: names ignoring case and surrounding spaces, date of birth exactly.
 */
export const kycMergeDetailsMatch = (kept: KycMergePersonDetails, verified: KycMergePersonDetails): boolean =>
  normalise(kept.firstName) === normalise(verified.firstName)
  && normalise(kept.surname) === normalise(verified.surname)
  && kept.dateOfBirth.trim() === verified.dateOfBirth.trim();

/**
 * Shown in the merge dialog and stored on the KYC result the merge moves to Under review; each caller
 * adds how the review is reached.
 */
export const kycMergeMismatchMessage = (kept: KycMergePersonDetails, verified: KycMergePersonDetails): string =>
  `After merging, the passed KYC (${fullName(verified)}, ${displayDob(verified.dateOfBirth)}) ` +
  `does not match ${fullName(kept)} (${displayDob(kept.dateOfBirth)}).`;
